import React, { useState, useEffect, useCallback, useRef } from 'react'

import { API, Storage } from 'aws-amplify'
import { getStaffProfile } from './../../../managers/graphql/queries'

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress';
import { COLORS } from '../../../theme/muiTheme';

import { useDropzone } from 'react-dropzone'

// redux
import { useAppDispatch, useAppSelector } from '../../../hooks'
import { getOrganizationStaffProfiles } from '../../../managers/redux/slices/organization'
import { FundraisingCampaignType, Program, StaffProfile } from '../../../API';
import StaffSelector from '../../inputs/StaffSelector';
import { createBackendFundraisingCampaign, getFundraisingCampaigns, clearSelectedCampaign, manageFundraisingCampaignUpdate, getFundraisingCampaignUpdates, clearSelectedCampaignUpdate } from '../../../managers/redux/slices/fundraising';
import RichTextEditor, { EditorValue } from 'react-rte';
import { updateFundraisingCampaignUpdate } from '../../../managers/graphql/mutations';
import { setLoading } from '../../../managers/redux/slices/loading';

interface ManageCampaignUpdateDialogProps {
    visible: boolean,
    onClose: () => void
}

export default function ManageCampaignUpdate(props: ManageCampaignUpdateDialogProps) {

    const [id, setId] = useState<string | null>(null)

    // form inputs
    const [visibility, setVisibility] = useState<'public' | 'ambassadorsOnly'>('ambassadorsOnly')
    const [message, setMessage] = useState<string | null>(null)
    const [url, setUrl] = useState<string | null>(null)
    const [assetsUploaded, setAssetsUploaded] = useState<number>(0)
    const [live, setLive] = useState<boolean>(false)

    const [updateAssetFile, setUpdateAssetFile] = useState<any>(null)
    const [updateAssetFileAdded, setUpdateAssetFileAdded] = useState<boolean>(false)
    const [updateAssetFileURI, setUpdateAssetFileURI] = useState<string | null>(null)

    const [invalidMessage, setInvalidMessage] = useState<boolean>(false)

    const dispatch = useAppDispatch()

    const organization = useAppSelector(state => state.organization)
    const selectedCampaignUpdate = useAppSelector(state => state.fundraising.selectedCampaignUpdate)

    const idRef = useRef<string | null>()

    idRef.current = id

    function handleClose() {
        setId(null)
        setVisibility('ambassadorsOnly')
        setMessage(null)
        setUrl(null)
        setAssetsUploaded(0)
        setLive(false)
        dispatch(clearSelectedCampaignUpdate(null))
        props.onClose()
    }

    useEffect(() => {
        (async () => {
            if (selectedCampaignUpdate) {
                if (selectedCampaignUpdate.id) setId(selectedCampaignUpdate.id)
                if (selectedCampaignUpdate.public) setVisibility('public')
                else setVisibility('ambassadorsOnly')
                if (selectedCampaignUpdate.message) setMessage(selectedCampaignUpdate.message)
                if (selectedCampaignUpdate.updateURL) setUrl(selectedCampaignUpdate.updateURL)
                if (selectedCampaignUpdate.live) setLive(selectedCampaignUpdate.live)
                if (selectedCampaignUpdate.assetsUploaded && selectedCampaignUpdate.assetsUploaded == 1) {
                    const uri = await Storage.get(`organizations/updates/${selectedCampaignUpdate.id}/asset${0}`)
                    console.log(uri)
                    setUpdateAssetFileURI(uri)
                    setUpdateAssetFileAdded(true)
                }
            }
        })()
    }, [selectedCampaignUpdate, props.visible])

    useEffect(() => {
        console.log('update: ', selectedCampaignUpdate)
        console.log('id: ', id)
    }, [selectedCampaignUpdate, id])

    async function uploadImage(props: { acceptedFiles: any }) {
        dispatch(setLoading({ loading: true, message: 'Uploading file...' }))

        console.log(props.acceptedFiles[0])
        if (idRef.current) {
            try {
                setUpdateAssetFile(props.acceptedFiles[0])

                console.log(selectedCampaignUpdate, id)

                const assetUpload = await Storage.put(`organizations/updates/${idRef.current}/asset${0}`, props.acceptedFiles[0], {
                    contentType: props.acceptedFiles[0].type
                })

                console.log(assetUpload)

                const { data }: any = await API.graphql({
                    query: updateFundraisingCampaignUpdate,
                    variables: {
                        input: {
                            id: idRef.current,
                            assetsUploaded: 1
                        }
                    }
                })

                console.log(data)

                const uri = await Storage.get(`organizations/updates/${idRef.current}/asset${0}`)
                console.log(uri)
                setUpdateAssetFileURI(uri)
                setUpdateAssetFileAdded(true)
            } catch (err) {
                console.log(err)
            }
        } else {
            console.log('selected campaign update: ', selectedCampaignUpdate, id)
        }

        dispatch(setLoading({ loading: false, message: 'Uploading file...' }))

    }

    const onDrop = useCallback(async acceptedFiles => {
        // Do something with the files
        uploadImage({ acceptedFiles })
    }, [])

    const { acceptedFiles, getRootProps, getInputProps, isDragActive } = useDropzone({ maxFiles: 1, accept: 'image/png,image/jpg,image/jpeg', onDrop: onDrop, maxSize: 104857600 });

    return (
        <Dialog open={props.visible} onClose={() => {

        }} maxWidth="lg" fullWidth sx={{ zIndex: 99 }}>
            <div className="d-grid col p-5 pb-0">
                <div className="row">
                    <Typography variant="h3" sx={{ padding: 0 }}>Campaign update</Typography>
                </div>
            </div>
            <div className="row p-5" style={{ backgroundColor: COLORS.WHITE }}>
                <div className="col-12 py-3">
                    <FormControlLabel checked={live} onChange={(e, checked) => setLive(checked)} control={<Switch />} label="Live" />
                </div>
                <div className="col-12 py-3">
                    <Typography variant="body1">Visibility</Typography>
                    <Select
                        value={visibility}
                        onChange={(e) => {
                            if (e.target.value == 'everyone') setVisibility('public')
                            if (e.target.value == 'ambassadorsOnly') setVisibility('ambassadorsOnly')
                        }}
                        fullWidth
                        label="Visibility"
                    >
                        <MenuItem value={'ambassadorsOnly'}>Ambassadors Only</MenuItem>
                        <MenuItem value={'everyone'}>Everyone</MenuItem>
                    </Select>
                </div>
                <div className="col-12 py-3">
                    <TextField
                        multiline
                        minRows={3}
                        variant='outlined'
                        type="text"
                        id="name"
                        placeholder="Update message"
                        value={message}
                        onChange={e => {
                            setMessage(e.target.value)
                        }}
                        sx={{ width: '100%' }}
                        label="Update message"
                    />
                </div>
                <div className="col-12 py-3">
                    <TextField
                        variant='outlined'
                        type="text"
                        id="name"
                        placeholder="Update URL"
                        value={url}
                        onChange={e => {
                            setUrl(e.target.value)
                        }}
                        sx={{ width: '100%' }}
                        label="Update URL"
                    />
                </div>
                <div className="col-lg-12 py-3">
                    <Typography variant="body1" sx={{ padding: 0 }}>Update image</Typography><br />
                    {/* {
                        updateAssetFile ?
                            <div className="d-flex flex-row justify-content-start align-items-center">
                                {
                                    updateAssetFileURI ?
                                        <video style={{ height: 100, width: 'auto' }} src={updateAssetFileURI} />
                                        :
                                        <Typography variant="body1">asset uploaded</Typography>
                                }
                                <Button onClick={() => { setUpdateAssetFileAdded(false); setUpdateAssetFileURI(null); setUpdateAssetFile(null) }} variant="outlined" className="mx-2">Upload new file</Button>
                            </div>
                            :
                            <input
                                id="updateAssetFileDropper"
                                type="file"
                                name="updateAsset"
                                accept=".jpg,.png"
                                placeholder="Upload your update image"
                                onChange={(e) => {
                                    if (e.target.files && e.target.files.length == 1) {
                                        setUpdateAssetFile(e.target.files[0])
                                        setUpdateAssetFileAdded(true)
                                        console.log(e.target.files[0])
                                    }
                                }}
                                className="my-2"
                            />
                    } */}
                    {
                        (updateAssetFile || updateAssetFileURI) && updateAssetFileAdded ?
                            <section className="m-0 mb-5 d-flex flex-column justify-content-center" style={{ height: 300, width: '100%', borderRadius: 15 }}>
                                <img src={updateAssetFileURI ? updateAssetFileURI : ''} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 15 }} />
                                <Button style={{ alignSelf: 'flex-end' }} onClick={() => {
                                    if (updateAssetFileAdded) {
                                        setUpdateAssetFileAdded(false)
                                    }
                                }}>
                                    Change Image
                                </Button>
                            </section>
                            :
                            <section className="p-5 m-0 mb-3 d-flex flex-column justify-content-center" style={{ borderWidth: 1, borderStyle: 'dashed', borderColor: 'black', height: 300, borderRadius: 15 }}>
                                <div {...getRootProps({ className: 'dropzone h-100 w-100' })} style={{ backgroundImage: updateAssetFileURI ? updateAssetFileURI : '' }}>
                                    <input {...getInputProps()} />
                                    {
                                        isDragActive ?
                                            <p style={{ width: '100%', textAlign: 'center' }}>Drop the files here</p>
                                            :
                                            <p style={{ width: '100%', textAlign: 'center' }}>Drag an image here, or click to select a file.</p>
                                    }
                                </div>
                                {
                                    updateAssetFileAdded ?
                                        <Button style={{ alignSelf: 'flex-end' }} onClick={() => {
                                            setUpdateAssetFileAdded(false)
                                        }}>
                                            Cancel
                                        </Button>
                                        :
                                        <div></div>
                                }
                            </section>
                    }
                </div>
            </div>
            <DialogActions style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <Button onClick={handleClose} size="large" variant="outlined" sx={{ width: '25%' }} >Cancel</Button>
                <Button
                    onClick={async () => {
                        if (message == '' || message == null) {
                            setInvalidMessage(true)
                        }
                        if (message != null && message != '') {
                            const manageFundraisingCampaignUpdateResponse = await dispatch(manageFundraisingCampaignUpdate({
                                id: id,
                                public: visibility == 'public',
                                message: message ? message : '',
                                url,
                                live: live
                            }))

                            console.log('manage new campaign update response: ', manageFundraisingCampaignUpdateResponse)

                            if (manageFundraisingCampaignUpdateResponse.payload) {
                                dispatch(getFundraisingCampaignUpdates({ campaignId: undefined }))
                                handleClose()
                            } else {
                                alert('An error occurred. Try again in a little bit or contact support.')
                            }

                        }
                    }}
                    size="large"
                    variant="contained"
                    sx={{ width: '25%' }}
                >
                    {id ? 'Update' : 'Create'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}